import {injectable} from "inversify";
import {QueryOrderInterface} from "@/modules/vue/interfaces";
import {Player} from "@/modules/team/entity";
import {SelectQueryBuilder} from "typeorm";
import {OrderType} from "@/modules/vue/types";

@injectable()
export class PlayerQueryOrder implements QueryOrderInterface<Player> {
  getDefaultField(): string {
    return 'player.skill';
  }

  getDefaultOrder(): OrderType {
    return 'DESC';
  }

  getOnlySingleOrder(): {[key: string]: OrderType} {
    return {};
  }

  getFields(): { [key: string]: string } {
    return {
      'player.skill': translator.t('skill'),
      'player.age': translator.t('age'),
      'player.marketValue': translator.t('market_value'),
    };
  }

  apply(query: SelectQueryBuilder<Player>, field: string | null, order: OrderType | null): SelectQueryBuilder<Player> {
    if (field === null) {
      field = this.getDefaultField();
    }

    if (order === null) {
      order = this.getDefaultOrder();
    }

    return query.addOrderBy(field, order);
  }
}